/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Timecodes_TextInputs */

const en_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was the Event Group created using a subtitle file with timecodes?`)
};

const fr_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe d’événements a-t-il été créé à partir d’un fichier de sous-titres avec codes temporels ?`)
};

const de_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wurde die Ereignisgruppe mithilfe einer Untertiteldatei mit Zeitcodes erstellt?`)
};

const it_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo di eventi è stato creato utilizzando un file di sottotitoli con codici temporali?`)
};

const ru_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Была ли группа событий создана с использованием файла субтитров с временными метками?`)
};

const es_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El grupo de eventos se creó utilizando un archivo de subtítulos con códigos de tiempo?`)
};

const zh_cn2_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组是否使用带有时间码的字幕文件创建？`)
};

const ja_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループは、タイムコード付きの字幕ファイルを使用して作成されましたか?`)
};

const hi_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या इवेंट ग्रुप को टाइमकोड वाली सबटाइटल फ़ाइल का उपयोग करके बनाया गया था?`)
};

const pt_pt2_event_group_timecodes_text = /** @type {(inputs: Event_Group_Timecodes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de eventos foi criado usando um arquivo de legenda com códigos de tempo?`)
};

/**
* | output |
* | --- |
* | "Was the Event Group created using a subtitle file with timecodes?" |
*
* @param {Event_Group_Timecodes_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_timecodes_text = /** @type {((inputs?: Event_Group_Timecodes_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Timecodes_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_timecodes_text(inputs)
	if (locale === "de") return de_event_group_timecodes_text(inputs)
	if (locale === "it") return it_event_group_timecodes_text(inputs)
	if (locale === "ru") return ru_event_group_timecodes_text(inputs)
	if (locale === "es") return es_event_group_timecodes_text(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_timecodes_text(inputs)
	if (locale === "ja") return ja_event_group_timecodes_text(inputs)
	if (locale === "hi") return hi_event_group_timecodes_text(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_timecodes_text(inputs)
	return en_event_group_timecodes_text(inputs)
});